

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface AdmissionInitialAssessmentParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface AdmissionAdministrativeMasterParameter extends Parameter {
  searchTerm: number;
  orderBy: string;

}


export interface AdmissionInitialAssessment {
    id?: any;
    referralNotes:string;
    admissionDiagnosis:any;
    woundDetail:any;
    procedureNotes:any
    diagnosisId:string;
    admissionId:number;
    tenantId: any;
    branchId: any;
  parameters?: AdmissionInitialAssessmentParameter[];
  links?: any;
  approvalDet?: any,
  approvalId?: any,
  isConscious?:boolean
}


export interface AdmissionAdministrativeMaster {

id?: any;

attenderName: any;
attenderAddress: any;
attenderMobile: any;
refMode: any;
refDocId: any;
refEmpId: any;
refClinicId: any;
othersPhone: any;
othersName: any;
othersAddress: any;
dischargeMode: any;
lamaDeath: any;
mlcPatient:any;
insurancePatient: any;
officeNotes: any;
admissionId: any;
parameters?: AdmissionAdministrativeMasterParameter[];
links?: any;
tenantId:string;
branchId:string;
regId?:string;
updatedBy?:any;
treatingPhyId : any;
treatmentPlan :any;
treatmentPlannedduration : number
treatmentEstimateCost : number;
approvalDet?: any;
approvalId?: any;
refRegId?:any;
}


export abstract class AdmissionInitialAssessmentData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<AdmissionInitialAssessment[]>;
  abstract create(url: string, data: AdmissionInitialAssessment): Observable<AdmissionInitialAssessment>;
  abstract update(url: string, data: AdmissionInitialAssessment): Observable<AdmissionInitialAssessment>;
  abstract delete(url: string): Observable<any>;


  //AdmissionAdministrativeMaster

  abstract listAdm(url: string): Observable<AdmissionAdministrativeMaster[]>;
  abstract createAdm(url: string, data: AdmissionAdministrativeMaster): Observable<AdmissionAdministrativeMaster>;
  abstract updateAdm(url: string, data: AdmissionAdministrativeMaster): Observable<AdmissionAdministrativeMaster>;
  abstract deleteAdm(url: string): Observable<any>;

}
